import React from 'react';
import {
    Button,
    makeStyles
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    btn: {
        backgroundColor: '#F5F5F5',
        border: `1px solid #F5F5F5`,
        opacity: 1,
        color: theme.palette.primary.dark,
        '&:hover': {
            backgroundColor: 'white',
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },
        paddingLeft: 8,
        paddingRight: 8,
        fontSize: 14,
        fontWeight: 500,
        height: 40,
        letterSpacing: 1,
        borderRadius: 4,
        fontFamily: 'Kanit-Medium'
    },
}));

const ButtonSecondary = ({
    title = "",
    variant = "contained",
    style,
    onClick,
    to,
    fullWidth,
    size = "",
    disabled
}) => {
    const classes = useStyles();

    return (
        <>
            {to ? (
                <Button
                    // color=""
                    variant={variant}
                    fullWidth={fullWidth}
                    style={style}
                    className={classes.btn}
                    size={size}
                    // to={to}
                    component={RouterLink}
                    disabled={disabled}
                >
                    {title}
                </Button>
            ) : (
                <Button
                    // color=""
                    variant={variant}
                    fullWidth={fullWidth}
                    style={style}
                    onClick={onClick}
                    className={classes.btn}
                    // size={size}
                    disabled={disabled}
                >
                    {title}
                </Button>
            )}
        </>
    )
};

ButtonSecondary.defaultProps = {
};

export default ButtonSecondary;